<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          :disabled="disabled && auditDisabled"
          size="mini"
          @submit.native.prevent
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_specName') || '产品规格'"
                prop="specName"
              >
                <el-input
                  v-model="formData.specName"
                  :placeholder="
                    $l('form_label_pl_specName') || '请输入产品规格'
                  "
                  :maxlength="200"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <GoodsSpecProcess
          ref="goodsSpecProcess"
          class="mt-2"
          :disabled="disabled"
          :auditDisabled="auditDisabled"
          :techList="formData.techList"
          :orderTechPricingSpecCode="formData.orderTechPricingSpecCode"
        />
        <BatchGoodsTable
          ref="batchGoodsTable"
          class="mt-2"
          :orderCode="orderCode"
          :disabled="disabled"
          :orderTechPricingCode="orderTechPricingCode"
          :orderTechPricingSpecCode="orderTechPricingSpecCode"
          :goodsList="formData.goodsList"
        />
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            v-if="!disabled || !auditDisabled"
            @click="add()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import GoodsSpecProcess from '../goods-spec-process'
import BatchGoodsTable from '../batch-goods'
import validate from '@/libs/util.validate'

import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    GoodsSpecProcess,
    BatchGoodsTable,
  },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    auditDisabled: { type: Boolean, default: false },
    orderCode: { type: String, default: '' },
    orderTechPricingCode: { type: String, default: '' },
    orderTechPricingSpecCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      fabricList: [],
      formData: { specName: '' },
      rules: {
        specName: [
          {
            required: true,
            message: this.$l('form_label_pl_specName') || '请输入产品规格',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {},
  methods: {
    getData() {
      if (this.orderTechPricingSpecCode) {
        this.$api
          .orderTechPricingGoodsSpecDetailApi({
            orderTechPricingSpecCode: this.orderTechPricingSpecCode,
            orderTechPricingCode: this.orderTechPricingCode,
          })
          .then((res) => {
            this.formData = res.body
          })
      }
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async add() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (!(await this.$refs.goodsSpecProcess.validate())) return
      const techList = this.$refs.goodsSpecProcess.getData()
      const goodsList = this.$refs.batchGoodsTable.getTableData()
      if (!techList || techList.length == 0) {
        this.$message({
          message: this.$l('form_label_pl_techList') || '请新增工时工价',
          type: 'warning',
        })
        return
      }
      if (!goodsList || goodsList.length == 0) {
        this.$message({
          message: this.$l('form_label_pl_goodsList') || '请选择订单产品',
          type: 'warning',
        })
        return
      }
      if (!this.auditDisabled) {
        const findData = goodsList.find(
          (item) => !item.orderTechPricingOrderGoodsCode
        )
        if (findData) {
          const confirm = await this.$confirm(
            '新增的订单产品将会生成产品报工记录,是否继续？',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          )
            .then(() => true)
            .catch(() => false)
          if (!confirm) return
        }
      }
      this.$emit('saveBatch', { ...this.formData, goodsList, techList })
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
